import * as React from 'react';
import { Switch, Route } from 'react-router';
import { AddQuestionnaire } from './AddQuestionnaire';
import { EditQuestionnaire } from './EditQuestionnaire';
import { QuestionnaireList } from './QuestionnaireList';

export class Questionnaire extends React.Component<{}, {}> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <Switch>
        <Route path='/dashboard/questionnaire/add' component={AddQuestionnaire} />
        <Route path='/dashboard/questionnaire/:id' component={EditQuestionnaire} />
        <Route exact path='/dashboard/questionnaire' component={QuestionnaireList} />
      </Switch>
    );
  }
}
